import config from "./config";

export const msalConfig = {
  auth: {
    clientId: config.REACT_APP_AD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${config.REACT_APP_AD_TENANT_ID}`,
    redirectUri: config.REACT_APP_URL
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }
};

export const loginRequest = {
  scopes: ["User.Read"],
  prompt: "select_account"
};
